import { matchPath } from 'react-router-dom';
import { getFeatureFlags } from 'utils/feature-flags';
import { rootPath } from 'utils/root-path';
import urls from './urls';

/**
 * List of pages that handle payment.
 *
 * This list is used to remove 3rd party scripts, except for those that process payment
 */
export const paymentPages = [urls.resolveOrderPayment]; // TODO Remove when checkout_excludeExternal is finally removed ane enabled by default
export const allPaymentPages = [urls.resolveOrderPayment, urls.checkout];

export function isPaymentPage(url: string | null | undefined) {
  if (!url) {
    return false;
  }
  const pathname = url.split('?', 2)[0];
  const { checkout_excludeExternal: excludeExternal } = getFeatureFlags() ?? {};

  return (excludeExternal ? allPaymentPages : paymentPages).some(path =>
    matchPath({ path }, pathname),
  );
}

// Functions for places where React Router is not available
const checkoutPath = rootPath('checkout');
const resolveOrderPaymentPath = rootPath('resolve-order-payment');

export function isCheckoutPath(pathname: string): boolean {
  return pathname.startsWith(checkoutPath);
}
function isResolveOrderPaymentPath(pathname: string): boolean {
  return pathname.startsWith(resolveOrderPaymentPath);
}
export function isPaymentPath(pathname: string): boolean {
  return isCheckoutPath(pathname) || isResolveOrderPaymentPath(pathname);
}
